import auth0 from 'auth0-js'

import { ROLES, TEN_YEARS_MSEC } from '~/core/constants'
import { base64UrlDecode, isIOSSafari } from '~/core/utils'

import { clearAuthCookie, setAuthCookie } from './cookie'
import envData from '~/core/env'

let webAuth

const isNamespaced = str => str.startsWith(envData.authCustomClaimNamespace)

const removeNamespace = str => isNamespaced(str)
  ? str.slice(envData.authCustomClaimNamespace.length)
  : str

const decodeRaw = token => {
  const [, payload] = token.split('.')
  return JSON.parse(base64UrlDecode(payload))
}

/* eslint-disable */
const decode = token => Object.fromEntries(
  Object.entries(decodeRaw(token))
    .filter(([claim]) => isNamespaced(claim))
    .map(([claim, value]) => [removeNamespace(claim), value])
);
/* eslint-enable */

export const normalizeUserInfo = idToken => {
  const customerId = idToken[`${envData.authCustomClaimNamespace}cid`]
  const role = idToken[`${envData.authCustomClaimNamespace}role`]
  const tenant = idToken[`${envData.authCustomClaimNamespace}tenant`]
  const email = idToken.email || idToken[`${envData.authCustomClaimNamespace}email`]
  const emailVerifiedFromToken = idToken.email_verified || idToken[`${envData.authCustomClaimNamespace}email_verified`]

  const { name, picture, sub: userId } = idToken
  const isAdmin = role === ROLES.ADMIN

  return {
    customerId,
    email,
    emailVerified: emailVerifiedFromToken === 'true' || emailVerifiedFromToken === true,
    isAdmin,
    name,
    picture,
    role,
    tenant,
    userId
  }
}

const getSession = () => new Promise((resolve, reject) => {
  webAuth.checkSession({}, async (error, authResult) => {
    if (error) {
      // Handle error
      console.error({ __filename, error }, 'Error getting session')
      clearAuthCookie()
      reject(new Error('Not authenticated'))
      return
    }

    setAuthCookie(Date.now() + TEN_YEARS_MSEC)

    resolve(authResult)
  })
})

export const getDomain = () => envData.authHostname

const init = async () => {
  webAuth = new auth0.WebAuth({
    audience: envData.authAudience,
    scope: 'openid profile email',
    redirectUri: `${window.location.origin}`,
    responseType: 'token id_token',
    clientID: envData.authClientId,
    domain: envData.authHostname,
    leeway: 300
  })

  const { accessToken, idTokenPayload } = await getSession()
  const userInfo = normalizeUserInfo(idTokenPayload)

  return {
    userInfo,
    accessToken
  }
}

const register = (params = {}) => {
  const options = {
    redirectUri: window.location.origin,
    prompt: 'select_account',
    mode: 'signUp',
    iosSafari: isIOSSafari(),
    ...params
  }

  webAuth.authorize(options)
}

export default {
  init,
  register
}
